import { mapUrlsToAttachmentField } from './mapUrlsToAttachmentField';

export const normalizePhotoValue = (val: any): any[] => {
  if (!val) return [];
  if (typeof val === 'string' && val.trim().length > 0) {
    return mapUrlsToAttachmentField([val]);
  }
  if (Array.isArray(val)) {
    const stringUrls = val.filter((item) => typeof item === 'string' && item.trim().length > 0);
    const objectItems = val.filter((item) => item && typeof item === 'object');
    const convertedStringUrls = stringUrls.length > 0 ? mapUrlsToAttachmentField(stringUrls) : [];
    return [...objectItems, ...convertedStringUrls];
  }
  if (typeof val === 'object') {
    return [val];
  }
  return [];
};
